<script setup>
    import { onMounted, reactive, ref, watch, computed } from 'vue';
    import { useCommonStore } from '@/stores/common';
    import ClientFeedback from '../components/ClientFeedback.vue'
    import PageContactUs from '../components/PageContactUs.vue';
    import ClarityInsights from '../components/ClarityInsights.vue';
    import ClarityGoogleReviews from '../components/ClarityGoogleReviews.vue';
    import ClarityHeroStats from '../components/ClarityHeroStats.vue';
    import axios from 'axios';

    const store = useCommonStore();
    
    const imgURL = ref(store.cloudfrontImgURL);
    const ctEndPoint = ref(store.customerThermometerURL);
    
    const autoScroll = ref();
    const cardDots = ref([true,false,false,false]);

    const showCardOne = ref(true);
    const cardOneFadeOutLeft = ref(false);
    const cardOneFadeOutRight = ref(false);
    const cardOneFadeInLeft = ref(false);
    const cardOneFadeInRight = ref(false);

    const showCardTwo = ref(false);
    const cardTwoFadeOutLeft = ref(false);
    const cardTwoFadeOutRight = ref(false);
    const cardTwoFadeInLeft = ref(false);
    const cardTwoFadeInRight = ref(false);

    const showCardThree = ref(false);
    const cardThreeFadeOutLeft = ref(false);
    const cardThreeFadeOutRight = ref(false);
    const cardThreeFadeInLeft = ref(false);
    const cardThreeFadeInRight = ref(false);

    const showCardFour = ref(false);
    const cardFourFadeOutLeft = ref(false);
    const cardFourFadeOutRight = ref(false);
    const cardFourFadeInLeft = ref(false);
    const cardFourFadeInRight = ref(false);

    const showMountains = ref(false);
    const showWhoWeAreContent = ref(false);
    const showWhoWhatContent = ref(false);

    const fum = ref(0);
    const clients = ref(0);
    const ctScore = ref(0);

    const isDesktop = ref(true);
    const isTablet = ref(false);
    const isMobile = ref(false);

    const tweened = reactive({
        fum: 0,
        clients: 1900,
        ctScore: 0
    });

    const homepageherosection = computed(() => `url('${imgURL.value}hero-banner-background.png')`); 
    const homepagewhowearetablet = computed(() => `url('${imgURL.value}homepage-background-ipad.png')`); 
    const homepagewhowearemobile = computed(() => `url('${imgURL.value}homepage-background-mobile.png')`); 
    const homepagewhowhat = computed(() => `url('${imgURL.value}homepage-background.png')`); 
    const homepagecardimg = computed(() => `url('${imgURL.value}homepage-box.png')`); 

    async function getClientSatisfactionScore() {
        var ct = '95.0%';
        await axios.get(ctEndPoint.value)
            .then(res => {
                ct = res.data;
            })
            .catch(err => {
                console.log(err);
            })    

        const ctInt = parseFloat(ct.slice(0,ct.length-1));
        if(ctInt > 90) {
            return ctInt;
        } else {
            return 90;
        }
    }

    function heroScrollClick(dir) {
        clearInterval(autoScroll.value);
        if(dir === 0) {
            heroCardsLeft();
        } else if(dir === 1) {
            heroCardsRight();
        }
    }

    function cardDotsClick(c) {
        clearInterval(autoScroll.value);
        switch(c) {
            case 1:
                cardDots.value = [true,false,false,false];
                if(showCardTwo.value) {
                    cardTwoFadeInRight.value = false;
                    cardTwoFadeOutLeft.value = true;
                    setTimeout(function() {
                        showCardTwo.value = false;
                        showCardOne.value = true;
                        cardOneFadeInRight.value = true;
                        cardTwoFadeOutLeft.value = false;
                    },450);  
                }
                if(showCardThree.value) {
                    cardThreeFadeInRight.value = false;
                    cardThreeFadeOutLeft.value = true;
                    setTimeout(function() {
                        showCardThree.value = false;
                        showCardOne.value = true;
                        cardOneFadeInRight.value = true;
                        cardThreeFadeOutLeft.value = false;
                    },450);  
                }
                if(showCardFour.value) {
                    cardFourFadeInRight.value = false;
                    cardFourFadeOutLeft.value = true;
                    setTimeout(function() {
                        showCardFour.value = false;
                        showCardOne.value = true;
                        cardOneFadeInRight.value = true;
                        cardFourFadeOutLeft.value = false;
                    },450);  
                }
                break;
            case 2:
                cardDots.value = [false,true,false,false];
                if(showCardOne.value) {
                    cardOneFadeInRight.value = false;
                    cardOneFadeOutLeft.value = true;
                    setTimeout(function() {
                        showCardOne.value = false;
                        showCardTwo.value = true;
                        cardTwoFadeInRight.value = true;
                        cardOneFadeOutLeft.value = false;
                    },450);
                    
                }
                if(showCardThree.value) {
                    cardThreeFadeInRight.value = false;
                    cardThreeFadeOutLeft.value = true;
                    setTimeout(function() {
                        showCardThree.value = false;
                        showCardTwo.value = true;
                        cardTwoFadeInRight.value = true;
                        cardThreeFadeOutLeft.value = false;
                    },450);  
                }
                if(showCardFour.value) {
                    cardFourFadeInRight.value = false;
                    cardFourFadeOutLeft.value = true;
                    setTimeout(function() {
                        showCardFour.value = false;
                        showCardTwo.value = true;
                        cardTwoFadeInRight.value = true;
                        cardFourFadeOutLeft.value = false;
                    },450);  
                }
                break;
            case 3:
                cardDots.value = [false,false,true,false];
                if(showCardOne.value) {
                    cardOneFadeInRight.value = false;
                    cardOneFadeOutLeft.value = true;
                    setTimeout(function() {
                        showCardOne.value = false;
                        showCardThree.value = true;
                        cardThreeFadeInRight.value = true;
                        cardOneFadeOutLeft.value = false;
                    },450);
                    
                }
                if(showCardTwo.value) {
                    cardTwoFadeInRight.value = false;
                    cardTwoFadeOutLeft.value = true;
                    setTimeout(function() {
                        showCardTwo.value = false;
                        showCardThree.value = true;
                        cardThreeFadeInRight.value = true;
                        cardTwoFadeOutLeft.value = false;
                    },450);  
                }
                if(showCardFour.value) {
                    cardFourFadeInRight.value = false;
                    cardFourFadeOutLeft.value = true;
                    setTimeout(function() {
                        showCardFour.value = false;
                        showCardThree.value = true;
                        cardThreeFadeInRight.value = true;
                        cardFourFadeOutLeft.value = false;
                    },450);  
                }
                break;
            case 4:
                cardDots.value = [false,false,false,true];
                if(showCardOne.value) {
                    cardOneFadeInRight.value = false;
                    cardOneFadeOutLeft.value = true;
                    setTimeout(function() {
                        showCardOne.value = false;
                        showCardFour.value = true;
                        cardFourFadeInRight.value = true;
                        cardOneFadeOutLeft.value = false;
                    },450);
                    
                }
                if(showCardTwo.value) {
                    cardTwoFadeInRight.value = false;
                    cardTwoFadeOutLeft.value = true;
                    setTimeout(function() {
                        showCardTwo.value = false;
                        showCardFour.value = true;
                        cardFourFadeInRight.value = true;
                        cardTwoFadeOutLeft.value = false;
                    },450);  
                }
                if(showCardThree.value) {
                    cardThreeFadeInRight.value = false;
                    cardThreeFadeOutLeft.value = true;
                    setTimeout(function() {
                        showCardThree.value = false;
                        showCardFour.value = true;
                        cardFourFadeInRight.value = true;
                        cardThreeFadeOutLeft.value = false;
                    },450);  
                }
                break;
            default:
                break;
        }
    }

    function heroCardsLeft(){
        if(showCardOne.value) {
            cardDots.value = [false,false,false,true];
            cardOneFadeInLeft.value = false;
            cardOneFadeOutRight.value = true;
            setTimeout(function() {
                showCardOne.value = false;
                showCardFour.value = true;
                cardFourFadeInLeft.value = true;
                cardOneFadeOutRight.value = false;
            },450);
            
        }
        if(showCardTwo.value) {
            cardDots.value = [true,false,false,false];
            cardTwoFadeInLeft.value = false;
            cardTwoFadeOutRight.value = true;
            setTimeout(function() {
                showCardTwo.value = false;
                showCardOne.value = true;
                cardOneFadeInLeft.value = true;
                cardTwoFadeOutRight.value = false;
            },450);  
        }
        if(showCardThree.value) {
            cardDots.value = [false,true,false,false];
            cardThreeFadeInLeft.value = false;
            cardThreeFadeOutRight.value = true;
            setTimeout(function() {
                showCardThree.value = false;
                showCardTwo.value = true;
                cardTwoFadeInLeft.value = true;
                cardThreeFadeOutRight.value = false;
            },450);  
        }
        if(showCardFour.value) {
            cardDots.value = [false,false,true,false];
            cardFourFadeInLeft.value = false;
            cardFourFadeOutRight.value = true;
            setTimeout(function() {
                showCardFour.value = false;
                showCardThree.value = true;
                cardThreeFadeInLeft.value = true;
                cardFourFadeOutRight.value = false;
            },450);  
        }
    }

    function heroCardsRight(){
        if(showCardOne.value) {
            cardDots.value = [false,true,false,false];
            cardOneFadeInRight.value = false;
            cardOneFadeOutLeft.value = true;
            setTimeout(function() {
                showCardOne.value = false;
                showCardTwo.value = true;
                cardTwoFadeInRight.value = true;
                cardOneFadeOutLeft.value = false;
            },450);
            
        }
        if(showCardTwo.value) {
            cardDots.value = [false,false,true,false];
            cardTwoFadeInRight.value = false;
            cardTwoFadeOutLeft.value = true;
            setTimeout(function() {
                showCardTwo.value = false;
                showCardThree.value = true;
                cardThreeFadeInRight.value = true;
                cardTwoFadeOutLeft.value = false;
            },450);  
        }
        if(showCardThree.value) {
            cardDots.value = [false,false,false,true];
            cardThreeFadeInRight.value = false;
            cardThreeFadeOutLeft.value = true;
            setTimeout(function() {
                showCardThree.value = false;
                showCardFour.value = true;
                cardFourFadeInRight.value = true;
                cardThreeFadeOutLeft.value = false;
            },450);  
        }
        if(showCardFour.value) {
            cardDots.value = [true,false,false,false];
            cardFourFadeInRight.value = false;
            cardFourFadeOutLeft.value = true;
            setTimeout(function() {
                showCardFour.value = false;
                showCardOne.value = true;
                cardOneFadeInRight.value = true;
                cardFourFadeOutLeft.value = false;
            },450);  
        }
    }

    watch(fum, (n) => {
        gsap.to(tweened, { duration: 1.0, fum: Number(n) || 0})
    });
    watch(clients, (n) => {
        gsap.to(tweened, { duration: 1.0, clients: Number(n) || 1998})
    });
    watch(ctScore, (n) => {
        gsap.to(tweened, { duration: 1.0, ctScore: Number(n) || 0})
    });

    function onScroll() {
        if(window.location.pathname === '/homepage' || window.location.pathname === '/') {
            var whoWeAreElm = null;
            whoWeAreElm = document.getElementById('homepage-who-we-are');            
            if(whoWeAreElm === null) {
                whoWeAreElm = document.getElementById('homepage-who-we-are-video-ipad');
            }    
            var whoWeAreElmPos = whoWeAreElm.getBoundingClientRect().top;

            if(whoWeAreElmPos < 600) {
                showMountains.value = true;
                setTimeout(function() {
                    showWhoWeAreContent.value = true;
                    loadWhoWhatContent();
                },500);
            }
        }
    }

    async function loadStatsValues() {
        const ct = await getClientSatisfactionScore();
        fum.value = 1000;
        clients.value = 1998;
        ctScore.value = ct;
    }
    
    function loadWhoWhatContent() {
        setTimeout(function() {
            showWhoWhatContent.value = true;
        },1000);   
    }

    function heroCarouselScroll() {
        autoScroll.value = setInterval(heroCardsRight,10000);
    }

    function viewportChange() {
        const viewportWidth = window.innerWidth;
        if(viewportWidth >= 1920) {
            isDesktop.value = true;  
            isTablet.value = false;
            isMobile.value = false;
        } else if(viewportWidth < 1920 && viewportWidth >= 1224) {
            isDesktop.value = true;
            isTablet.value = false;
            isMobile.value = false;
        } else if(viewportWidth < 1224 && viewportWidth >= 768) {
            isDesktop.value = false;
            isTablet.value = true;
            isMobile.value = false;
        } else if(viewportWidth < 768 ) {
            isDesktop.value = false;
            isTablet.value = false;
            isMobile.value = true;
        }
    }

    function canonicalLink() {
        var link = document.createElement('link');
        link.rel = 'canonical';
        link.href = 'https://www.clarityglobal.com/homepage';
        document.getElementsByTagName('head')[0].appendChild(link);
    }

    onMounted(() => {
        canonicalLink();
        store.metaDescriptionTag('homepage');
        store.schemaScript('homepage');
        window.addEventListener("scroll", onScroll);
        window.addEventListener("resize", viewportChange);
        heroCarouselScroll();
        loadStatsValues();
        viewportChange();
    });
</script>

<template>
    <div id="homepage-hero-section">
        <div id="homepage-hero-content" >
            <div class="clarity-margin-bottom-m">
                <h1 v-if="!isMobile" class="clarity-h1-white text-center clarity-padding-top-l">WEALTH MANAGERS</h1>
                <h1 v-if="!isMobile" class="clarity-h1-white text-center">SECURING YOUR FINANCIAL FUTURE</h1>
                <h1 v-if="isMobile" class="clarity-h3-white text-center clarity-padding-top-l">WEALTH MANAGERS</h1>
                <h1 v-if="isMobile" class="clarity-h3-white text-center">SECURING YOUR FINANCIAL FUTURE</h1>
            </div>
            
            <div v-if="isDesktop" id="homepage-hero-cards">
                <div @click="heroScrollClick(0)" id="homepage-hero-card-left"><span class="material-symbols-outlined">chevron_left</span></div>
                <div v-if="showCardOne" id="homepage-hero-card-one" class="flex justify-start" :class="{'fadeoutleft animation-duration-500':cardOneFadeOutLeft,'fadeinright animation-duration-500':cardOneFadeInRight,'fadeoutright animation-duration-500':cardOneFadeOutRight, 'fadeinleft animation-duration-500':cardOneFadeInLeft}">
                    <div class="clarity-margin-right-s">
                        <img class="hero-img" :src="imgURL+'homepage-hero-first-slide-image.png'" alt="Experienced Image">
                    </div>
                    <div class="content-center">
                        <p class="clarity-body-text-white"><b>EXPERIENCED</b><br>Founded over 25 years ago we have organically grown our business into a leading UK independent financial planning and investment firm.<br>Many of our original clients are still with us, and we are proud to have helped them achieve the financial security they now enjoy.</p>
                    </div> 
                </div>
                <div v-if="showCardTwo" class="flex justify-start" :class="{'fadeoutleft animation-duration-500':cardTwoFadeOutLeft,'fadeinright animation-duration-500':cardTwoFadeInRight,'fadeoutright animation-duration-500':cardTwoFadeOutRight, 'fadeinleft animation-duration-500':cardTwoFadeInLeft}">
                    <div class="clarity-margin-right-s">
                        <img class="hero-img" :src="imgURL+'homepage-hero-second-slide-image.png'" alt="Expert Image">
                    </div>
                    <div class="content-center">
                        <p class="clarity-body-text-white"><b>EXPERT</b><br>As one of the few Chartered Financial Planning Firms in the UK, our advisers are all Chartered Financial Planners.<br>We ensure all teams are always up-to-date with legislative and regulatory requirements, guaranteeing expert advice every step of the way.</p>
                    </div> 
                </div>
                <div v-if="showCardThree" class="flex justify-start" :class="{'fadeoutleft animation-duration-500':cardThreeFadeOutLeft,'fadeinright animation-duration-500':cardThreeFadeInRight,'fadeoutright animation-duration-500':cardThreeFadeOutRight, 'fadeinleft animation-duration-500':cardThreeFadeInLeft}">
                    <div class="clarity-margin-right-s">
                        <img class="hero-img" :src="imgURL+'homepage-hero-third-slide-image.png'" alt="Fair Image">
                    </div>
                    <div class="content-center">
                        <p class="clarity-body-text-white"><b>FAIR</b><br>We’ve been independent and fee-based since our inception, committed to transparency, integrity and fairness at all times, for all of our clients.</p>
                    </div> 
                </div>
                <div v-if="showCardFour" class="flex justify-start" :class="{'fadeoutleft animation-duration-500':cardFourFadeOutLeft,'fadeinright animation-duration-500':cardFourFadeInRight,'fadeoutright animation-duration-500':cardFourFadeOutRight, 'fadeinleft animation-duration-500':cardFourFadeInLeft}">
                    <div class="clarity-margin-right-s">
                        <img class="hero-img" :src="imgURL+'homepage-hero-fourth-slide-image.png'" alt="Flexible Image">
                    </div>
                    <div class="content-center">
                        <p class="clarity-body-text-white"><b>FLEXIBLE</b><br>We tailor our services to your unique needs, allowing you to choose the level of advice and support that fits your financial situation and goals.</p>
                    </div> 
                </div>  
                <div @click="heroScrollClick(1)" id="homepage-hero-card-right"><span class="material-symbols-outlined">chevron_right</span></div>
            </div>

            <div v-if="isTablet || isMobile" id="homepage-hero-cards">
                <div @click="heroScrollClick(0)" id="homepage-hero-card-left"><span class="material-symbols-outlined">chevron_left</span></div>
                <div v-if="showCardOne" id="homepage-hero-card-one" class="" :class="{'fadeoutleft animation-duration-500':cardOneFadeOutLeft,'fadeinright animation-duration-500':cardOneFadeInRight,'fadeoutright animation-duration-500':cardOneFadeOutRight, 'fadeinleft animation-duration-500':cardOneFadeInLeft}">
                    <div class="text-center flex justify-center">
                        <img class="hero-img" :src="imgURL+'homepage-hero-first-slide-image.png'" alt="Experienced Image">
                    </div>
                    <div class="text-center">
                        <p class="clarity-body-text-white"><b>EXPERIENCED</b><br>Founded over 25 years ago we have organically grown our business into a leading UK independent financial planning and investment firm.<br>Many of our original clients are still with us, and we are proud to have helped them achieve the financial security they now enjoy.</p>
                    </div> 
                </div>
                <div v-if="showCardTwo" class="" :class="{'fadeoutleft animation-duration-500':cardTwoFadeOutLeft,'fadeinright animation-duration-500':cardTwoFadeInRight,'fadeoutright animation-duration-500':cardTwoFadeOutRight, 'fadeinleft animation-duration-500':cardTwoFadeInLeft}">
                    <div class="text-center flex justify-center">
                        <img class="hero-img" :src="imgURL+'homepage-hero-second-slide-image.png'" alt="Expert Image">
                    </div>
                    <div class="text-center">
                        <p class="clarity-body-text-white"><b>EXPERT</b><br>As one of the few Chartered Financial Planning Firms in the UK, our advisers are all Chartered Finanical Planners.<br>We ensure all teams are always up-to-date with legislative and regulatory requirements, guaranteeing expert advice every step of the way.</p>
                    </div> 
                </div>
                <div v-if="showCardThree" class="" :class="{'fadeoutleft animation-duration-500':cardThreeFadeOutLeft,'fadeinright animation-duration-500':cardThreeFadeInRight,'fadeoutright animation-duration-500':cardThreeFadeOutRight, 'fadeinleft animation-duration-500':cardThreeFadeInLeft}">
                    <div class="text-center flex justify-center">
                        <img class="hero-img" :src="imgURL+'homepage-hero-third-slide-image.png'" alt="Fair Image">
                    </div>
                    <div class="text-center">
                        <p class="clarity-body-text-white"><b>FAIR</b><br>We’ve been independent and fee-based since our inception, committed to transparency, integrity and fairness at all times, for all of our clients.</p>
                    </div> 
                </div>
                <div v-if="showCardFour" class="" :class="{'fadeoutleft animation-duration-500':cardFourFadeOutLeft,'fadeinright animation-duration-500':cardFourFadeInRight,'fadeoutright animation-duration-500':cardFourFadeOutRight, 'fadeinleft animation-duration-500':cardFourFadeInLeft}">
                    <div class="text-center flex justify-center">
                        <img class="hero-img" :src="imgURL+'homepage-hero-fourth-slide-image.png'" alt="Flexible Image">
                    </div>
                    <div class="text-center">
                        <p class="clarity-body-text-white"><b>FLEXIBLE</b><br>We tailor our services to your unique needs, allowing you to choose the level of advice and support that fits your financial situation and goals.</p>
                    </div> 
                </div>  
                <div @click="heroScrollClick(1)" id="homepage-hero-card-right"><span class="material-symbols-outlined">chevron_right</span></div>
            </div>
            <div id="hero-card-dots" class="flex justify-center">
                <div @click="cardDotsClick(1)" :class="[cardDots[0] ? 'card-dot-selected' : 'card-dot']"></div>
                <div @click="cardDotsClick(2)" :class="[cardDots[1] ? 'card-dot-selected' : 'card-dot']"></div>
                <div @click="cardDotsClick(3)" :class="[cardDots[2] ? 'card-dot-selected' : 'card-dot']"></div>
                <div @click="cardDotsClick(4)" :class="[cardDots[3] ? 'card-dot-selected' : 'card-dot']"></div>
            </div>   
        </div>   
    </div>
    <ClarityHeroStats></ClarityHeroStats>

    <div id="homepage-who-we-are" v-if="isDesktop">
        <div id="homepage-mountains" v-if="showMountains">
            <img class="homepage-clouds-sky fadein animation-duration-100" :src="imgURL+'homepage-mountains/homepage-clouds-sky.png'" alt="Mountains Image">
            <img class="homepage-mountains-a fadein animation-duration-200" :src="imgURL+'homepage-mountains/homepage-mountains-01.png'" alt="Mountains Image">
            <img class="homepage-mountains-b fadein animation-duration-300" :src="imgURL+'homepage-mountains/homepage-mountains-02.png'" alt="Mountains Image"> 
            <img class="homepage-mountains-c fadein animation-duration-400" :src="imgURL+'homepage-mountains/homepage-mountains-03.png'" alt="Mountains Image">
            <img class="homepage-mountains-d fadein animation-duration-500" :src="imgURL+'homepage-mountains/homepage-mountains-04.png'" alt="Mountains Image">
            <img class="homepage-mountains-e fadein animation-duration-1000" :src="imgURL+'homepage-mountains/homepage-mountains-05.png'" alt="Mountains Image"> 
            <img class="homepage-trees fadein animation-duration-2000" :src="imgURL+'homepage-mountains/homepage-trees.png'" alt="Mountains Image">
            <img class="homepage-man fadein animation-duration-3000" :src="imgURL+'homepage-mountains/homepage-man.png'" alt="Mountains Image">
            <div id="homepage-who-we-are-content" class="grid grid-cols-2 gap-10 fadein animation-duration-1000" v-if="showWhoWeAreContent">
                <div>
                    <div class="who-we-are-video">
                        <div style="padding:56.25% 0 0 0;position:relative;">
                            <iframe src="https://player.vimeo.com/video/1044265587?dnt=1&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write" style="position:absolute;top:0;left:0;width:100%;height:100%;border-radius:15px;" title="clarity - Who We Are"></iframe>
                        </div>
                    </div>  
                </div>
                <div class="">
                    <h2 class="clarity-h2-blue mb-[20px]!">WHO ARE WE?</h2>
                    <p class="clarity-body-text mb-[20px]!">clarity is an award-winning firm of independent chartered financial planners, providing expert financial advice for over 25 years. Our independent, fee-based model ensures that we prioritise your best interests without being tied to any product providers or investment management groups.</p>
                    <p class="clarity-body-text mb-[20px]!">We are proud of our in-house proprietary systems – <span class="clarity-light-blue">clarityONLINE</span>, WealthPlan and VirtualWRAP. They have been developed and are maintained in-house to offer secure, seamless, and personalised financial management. Our independence allows us to recommend the most suitable financial solutions to meet your individual needs.</p>
                    <a href="/meettheteam"><button class="clarity-button-orange homepage-team-link">Meet the <span class="clarity-lower">clarity</span> Team</button></a>
                </div>
            </div> 
            <div id="homepage-who-what">
                <div v-if="showWhoWhatContent" id="homepage-who-what-content" class="grid grid-cols-2 gap-4 fadein animation-duration-1000">
                    <div class="homepage-card hover:shadow-8">
                        <div class="homepage-card-img">
                            <img :src="imgURL+'homepage-office.png'" alt="What we Do">
                        </div>
                        <div>
                            <h3 class="clarity-h3-light-blue clarity-margin-top-s mb-[20px]!">WHAT WE DO</h3>
                            <h5 class="clarity-h5-blue mb-[20px]!">Your Wealth, Your Legacy, Your Clarity</h5>
                            <p class="clarity-body-text mb-[20px]!">At clarity we specialise in helping individuals and families navigate through the complex world of financial planning, ensuring long-term financial security and legacy protection.</p>
                            <p class="clarity-body-text mb-[20px]!">Our bespoke financial strategies are designed to help you grow and safeguard your wealth, providing peace of mind today and for future generations.</p>
                            <p class="clarity-body-text mb-[20px]!">In addition to our personal financial planning and investment management advice, we offer specialist services for trustees and employers.</p>
                        </div>
                        <div>
                            <a href="/whatwedo"><button class="clarity-button-orange homepage-who-what-button-one">Explore Our Services</button></a>
                        </div>
                    </div>
                    <div class="homepage-card hover:shadow-8">
                        <div class="homepage-card-img">
                            <img :src="imgURL+'homepage-adviser-with-clients.png'" alt="Who we Help">
                        </div>
                        <div>
                            <h3 class="clarity-h3-light-blue clarity-margin-top-s mb-[20px]!">WHO WE HELP</h3>
                            <h5 class="clarity-h5-blue mb-[20px]!">You, Your Family, Your Employees</h5>
                            <p class="clarity-body-text mb-[20px]!">For over 25 years, clarity has supported individuals, families, and businesses with retirement, estate, and wealth planning. Our tailored solutions address each client’s unique needs, delivering the best possible outcomes.</p>
                            <p class="clarity-body-text mb-[20px]!">We also specialise in trustee management, guiding clients through all the financial and legal complexities.</p>
                            <p class="clarity-body-text mb-[20px]!">Our award-winning benefits communication platform helps employers maximise the value of their employee benefits spend.</p>
                        </div>
                        <div>
                            <a href="whowehelp"><button class="clarity-button-orange homepage-who-what-button-two">Find Out How We Can Help You</button></a>
                        </div>   
                    </div>
                </div>
            </div>
        </div>
    </div>
         
    <div id="homepage-who-we-are-video-ipad" v-if="isTablet">
        <div style="padding:56.25% 0 0 0;position:relative;">
            <iframe src="https://player.vimeo.com/video/1044265587?dnt=1&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write" style="position:absolute;top:0;left:0;width:100%;height:100%;border-radius:15px;" title="clarity - Who We Are"></iframe>
        </div>
    </div>   
    <div id="homepage-who-we-are-ipad" v-if="isTablet">
        <h2 class="clarity-h2-blue mb-[20px]!">WHO ARE WE?</h2>
        <p class="clarity-body-text mb-[20px]!">clarity is an award-winning firm of independent chartered financial planners, providing expert financial advice for over 25 years. Our independent, fee-based model ensures that we prioritise your best interests without being tied to any product providers or investment management groups.</p>
        <p class="clarity-body-text mb-[20px]!">We are proud of our in-house proprietary systems – <span class="clarity-light-blue">clarityONLINE</span>, WealthPlan and VirtualWRAP. They have been developed and are maintained in-house to offer secure, seamless, and personalised financial management. Our independence allows us to recommend the most suitable financial solutions to meet your individual needs.</p>
        <a href="/meettheteam"><button class="clarity-button-orange homepage-team-link">Meet the <span class="clarity-lower">clarity</span> Team</button></a>
        <div id="homepage-who-what">
                <div v-if="showWhoWhatContent" id="homepage-who-what-content" class="grid grid-cols-2 gap-4 fadein animation-duration-1000">
                    <div class="homepage-card hover:shadow-8">
                        <div class="homepage-card-img">
                            <img :src="imgURL+'homepage-office.png'" alt="What we Do">
                        </div>
                        <h3 class="clarity-h3-light-blue clarity-margin-top-s mb-[20px]!">WHAT WE DO</h3>
                        <h5 class="clarity-h5-blue mb-[20px]!">Your Wealth, Your Legacy, Your Clarity</h5>
                        <p class="clarity-body-text mb-[20px]!">At clarity we specialise in helping individuals and families navigate through the complex world of financial planning, ensuring long-term financial security and legacy protection.</p>
                        <p class="clarity-body-text mb-[20px]!">Our bespoke financial strategies are designed to help you grow and safeguard your wealth, providing peace of mind today and for future generations.</p>
                        <p class="clarity-body-text mb-[20px]!">In addition to our personal financial planning and investment management advice, we offer specialist services for trustees and employers.</p>
                        <a href="/whatwedo"><button class="clarity-button-orange homepage-who-what-button-one">Explore Our Services</button></a>
                    </div>
                    <div class="homepage-card hover:shadow-8">
                        <div class="homepage-card-img">
                            <img :src="imgURL+'homepage-adviser-with-clients.png'" alt="Who we Help">
                        </div>
                        <h3 class="clarity-h3-light-blue clarity-margin-top-s mb-[20px]!">WHO WE HELP</h3>
                        <h5 class="clarity-h5-blue mb-[20px]!">You, Your Family, Your Employees</h5>
                        <p class="clarity-body-text mb-[20px]!">For over 25 years, clarity has supported individuals, families, and businesses with retirement, estate, and wealth planning. Our tailored solutions address each client’s unique needs, delivering the best possible outcomes.</p>
                        <p class="clarity-body-text mb-[20px]!">We also specialise in trustee management, guiding clients through all the financial and legal complexities.</p>
                        <p class="clarity-body-text mb-[20px]!">Our award-winning benefits communication platform helps employers maximise the value of their employee benefits spend.</p>
                        <a href="whowehelp"><button class="clarity-button-orange homepage-who-what-button-two">Find Out How We Can Help You</button></a>
                    </div>
                </div>
            </div>
    </div>

    <div id="homepage-who-we-are-mobile" v-if="isMobile">
        <div style="padding:56.25% 0 0 0;position:relative;">
            <iframe src="https://player.vimeo.com/video/1044265587?dnt=1&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write" style="position:absolute;top:0;left:0;width:100%;height:100%;border-radius:15px;" title="clarity - Who We Are"></iframe>
        </div>
        <h2 class="clarity-h2-blue clarity-margin-top-s mb-[20px]!">WHO ARE WE?</h2>
        <p class="clarity-body-text mb-[20px]!">clarity is an award-winning firm of independent chartered financial planners, providing expert financial advice for over 25 years. Our independent, fee-based model ensures that we prioritise your best interests without being tied to any product providers or investment management groups.</p>
        <p class="clarity-body-text mb-[20px]!">We are proud of our in-house proprietary systems – <span class="clarity-light-blue">clarityONLINE</span>, WealthPlan and VirtualWRAP. They have been developed and are maintained in-house to offer secure, seamless, and personalised financial management. Our independence allows us to recommend the most suitable financial solutions to meet your individual needs.</p>
        <a href="/meettheteam"><button class="clarity-button-orange homepage-team-link">Meet the <span class="clarity-lower">clarity</span> Team</button></a>
    </div>
    <div id="homepage-who-we-are-text-mobile" v-if="isMobile">
        <div class="homepage-card-img">
            <img :src="imgURL+'homepage-office.png'" alt="What we Do">
        </div>
        <h3 class="clarity-h3-light-blue clarity-margin-top-s mb-[20px]!">WHAT WE DO</h3>
        <h5 class="clarity-h5-blue mb-[20px]!">Your Wealth, Your Legacy, Your Clarity</h5>
        <p class="clarity-body-text mb-[20px]!">At clarity we specialise in helping individuals and families navigate through the complex world of financial planning, ensuring long-term financial security and legacy protection.</p>
        <p class="clarity-body-text mb-[20px]!">Our bespoke financial strategies are designed to help you grow and safeguard your wealth, providing peace of mind today and for future generations.</p>
        <p class="clarity-body-text mb-[20px]!">In addition to our personal financial planning and investment management advice, we offer specialist services for trustees and employers.</p>
        <a href="/whatwedo"><button class="clarity-button-orange homepage-who-what-button-one">Explore Our Services</button></a>
        <div class="homepage-card-img clarity-margin-top-m">
            <img style="left:60px" :src="imgURL+'homepage-adviser-with-clients.png'" alt="Who we Help">
        </div>
        <h3 class="clarity-h3-light-blue clarity-margin-top-s mb-[20px]!">WHO WE HELP</h3>
        <h5 class="clarity-h5-blue mb-[20px]!">You, Your Family, Your Employees</h5>
        <p class="clarity-body-text mb-[20px]!">For over 25 years, clarity has supported individuals, families, and businesses with retirement, estate, and wealth planning. Our tailored solutions address each client’s unique needs, delivering the best possible outcomes.</p>
        <p class="clarity-body-text mb-[20px]!">We also specialise in trustee management, guiding clients through all the financial and legal complexities.</p>
        <p class="clarity-body-text mb-[20px]!">Our award-winning benefits communication platform helps employers maximise the value of their employee benefits spend.</p>
        <a href="whowehelp"><button class="clarity-button-orange homepage-who-what-button-two">Find Out How We Can Help You</button></a>
    </div>
 
    <ClientFeedback feedback-source="all"></ClientFeedback>
    <ClarityInsights insight-type="homepage"></ClarityInsights>
    <ClarityGoogleReviews></ClarityGoogleReviews>
    <PageContactUs></PageContactUs>
</template>

<style lang="css" scoped>
    #homepage-hero-section {
        max-width: 100%;
        background-image: v-bind(homepageherosection);
    }
    #homepage-hero-content {
        padding-left: calc(15%);
        padding-right: calc(15%);
        padding-bottom: 40px;
    }
    .hero-img {
        max-width: 337px;
        height: auto;
    }
    #homepage-hero-cards {
        position: relative;
    }
    #homepage-hero-card-left {
        position: absolute;
        left: -20px;
        top: 80px;
        width: 40px;
        height: 40px;
        background-color: var(--clarity-pure-white);
        border: 1px solid var(--clarity-grey);
        border-radius: 50px;
        cursor: pointer;
    }
    #homepage-hero-card-left .material-symbols-outlined {
        padding-left: 5px;
        line-height: 40px;
    }
    #homepage-hero-card-right {
        position: absolute;
        right: -20px;
        top: 80px;
        width: 40px;
        height: 40px;
        background-color: var(--clarity-pure-white);
        border: 1px solid var(--clarity-grey);
        border-radius: 50px;
        cursor: pointer;
    }
    #homepage-hero-card-right .material-symbols-outlined {
        padding-left: 8px;
        line-height: 40px;
    }
    #homepage-who-we-are-ipad {
        width: 100%;
        padding-top: 30px;
        padding-left: calc(9%);
        padding-right: calc(9%);
        height: 2000px;
        background-image: v-bind(homepagewhowearetablet);
        background-repeat: no-repeat;
        background-size: cover;
    }
    #homepage-who-we-are-video-ipad {
        margin-top: 60px;
        padding-left: calc(9%);
        padding-right: calc(9%);
        width: 100%;
        background-color: var(--clarity-pure-white);
    }
    #homepage-who-we-are-mobile {
        padding: 45px 20px 400px 20px;
        background-image: v-bind(homepagewhowearemobile);
        background-position: bottom;
        background-repeat: no-repeat;
        background-size: contain;
    }
    #homepage-who-we-are-text-mobile {
        padding: 45px 20px;
    }
    #homepage-who-we-are {
        position: relative;
        width: 100%;
        height: 1900px;
        background-color: var(--clarity-pure-white);
    }
    #homepage-who-we-are img {
        position: absolute;
        left: 0px;
    }
    .homepage-mountains-a {
        top: 502px;
        width: 100%;
    }
    .homepage-mountains-b {
        top: 600px;
        width: 100%;
    }
    .homepage-mountains-c {
        top: 704px;
        width: 100%;
    }
    .homepage-mountains-d {
        top: 554px;
        width: 100%;
    }
    .homepage-mountains-e {
        top: 730px;
        width: 100%;
    }
    .homepage-trees {
        z-index: 500;
        top: 364px;
        width: 100%;
    }
    .homepage-clouds-sky {
        top: 36px;
        width: 100%;
    }
    .homepage-man {
        z-index: 500;
        top: 502px;
        max-width: 100% !important;
        
    } 
    #homepage-who-we-are-content {
        position: absolute;
        top: 120px;
        left: calc(15%);
        right:calc(15%);
    }
    #homepage-who-we-are-content button {
        cursor: pointer;
    }
    #homepage-who-what {
        position: relative;
        top: 850px;
        max-width: 100%;
        height: 1050px;
        background-image: v-bind(homepagewhowhat);
        background-position: bottom;
        background-repeat: no-repeat;
        background-size: cover;
    }
    #homepage-who-what-content {
        z-index: 600;
        position: absolute;
        left: calc(15%);
        right:calc(15%);
    }
    .homepage-card {
        background: var(--clarity-pure-white) 0% 0% no-repeat padding-box;
        box-shadow: 0px 5px 20px #0000001A;
        border-radius: 27px;
        opacity: 1;
        padding: 30px;
    }
    .homepage-card:first-of-type {
        margin-right: 15px;
    }
    .homepage-card:last-of-type {
        margin-left: 15px;
    }
    .homepage-card img {
        position: relative !important;
        max-width: 100%;
        height: auto;
    }
    .homepage-card-img {
        height: 370px;
        border-radius: 27px;
        padding: 20px;
        background-image: v-bind(homepagecardimg);
        background-repeat: no-repeat;
        background-size: cover;
        text-align: center;
    }
    .homepage-who-what-button-one {
        width: 264px;
        height: 54px;
    }
    .homepage-who-what-button-two {
        width: 356px;
        height: 54px;
    }
    .homepage-team-link {
        position: relative;
        z-index: 600;
        width: 270px;
        height: 54px;
    }
    #hero-card-dots {
        margin-top: 45px;
    }
    .card-dot {
        cursor: pointer;
        width: 15px;
        height: 15px;
        margin-right: 15px;
        background: #FFFFFF40 0% 0% no-repeat padding-box;
        border-radius: 15px;
        opacity: 1;
    }
    .card-dot-selected {
        cursor: pointer;
        width: 15px;
        height: 15px;
        margin-right: 15px;
        background: var(--clarity-pure-white) 0% 0% no-repeat padding-box;
        border: 1px solid var(--clarity-pure-white);
        border-radius: 15px;
        opacity: 1;
    }
    .clarity-lower {
        text-transform: lowercase;
    }
    .who-we-are-video {
        position: relative;
        z-index: 600;
    }

    /* TABLET */
    @media only screen and (max-width: 1224px) {
        #homepage-hero-content {
            padding-left: calc(9%);
            padding-right: calc(9%);
        }
        #homepage-who-what {
            position: relative;
            top: 520px;
            max-width: 100%;
            height: initial;
            background-image: none;    
        }
        #homepage-who-what-content, #homepage-who-we-are-content, #homepage-who-what-content {
            left: 0;
            right:0;
        }
        .homepage-card-img {
            height: 200px;
        }
        .homepage-card-img img {
            height: 170px;
            width: auto;
        }
        .grid {
            flex-wrap: nowrap !important;
        }
    }
    @media only screen and (max-width: 940px) {
        .homepage-card {
            padding: 10px;
        }
    }
    @media only screen and (max-width: 800px) {
        #homepage-who-we-are-ipad {
            padding-left: 20px;
            padding-right: 20px;
        }
        #homepage-who-what {
            top: 400px;
        }  
    }
    /* MOBILE */
    @media only screen and (max-width: 767px) {
        #homepage-hero-content, /*#homepage-clarity-stats-content,*/ #homepage-who-we-are-content, #homepage-who-what-content {
            padding-left: 20px;
            padding-right: 20px;
        }
        #homepage-hero-cards {
            margin-left: 20px;
            margin-right: 20px;
        }
        #homepage-who-what {
            height: 2000px;
        }
        .grid {
            flex-wrap: wrap !important;
        }
    }
    /* Mobile */
    @media only screen and (max-width: 445px) {
        #homepage-who-we-are-mobile {
            padding: 45px 20px 270px 20px;
        }
    }
    @media only screen and (max-width: 375px) {
        .hero-img {
            max-width: 250px;
            height: auto;
        }
        .homepage-who-what-button-two {
            width: auto;
            height: auto;
            padding: 10px 20px;
        }
    }
</style>